// apps/client/src/hooks/normaliseNetShare.ts
//
// Pure rule, kept out of the hook so it can be tested without pulling in
// firebase (importing the hook initialises auth and fails under jest).

/**
 * Normalise the net-share figures off a raw overview payload.
 *
 * Falls back to the SHARE figures, never to zero: a client cached from before
 * the callable returned net would otherwise blank every broker's Total Paid,
 * Amt on Top and Carry Over — a worse failure than the overstatement this fixes.
 *
 * Uses `??` and not `||` throughout: a broker who has allocated their entire
 * share away genuinely nets 0, and `||` would silently substitute the gross.
 */
export function normaliseNetShare(b: {
  totalBrokerShareCents?: number;
  totalBrokerNetCents?: number;
  monthlyBrokerShare?: { month: string; cents: number }[];
  monthlyBrokerNet?: { month: string; cents: number }[];
  totalRecipientAllocatedCents?: number;
}): {
  totalBrokerNetCents: number;
  monthlyBrokerNet: { month: string; cents: number }[];
  totalRecipientAllocatedCents: number;
} {
  return {
    totalBrokerNetCents: b.totalBrokerNetCents ?? b.totalBrokerShareCents ?? 0,
    monthlyBrokerNet: Array.isArray(b.monthlyBrokerNet)
      ? b.monthlyBrokerNet
      : Array.isArray(b.monthlyBrokerShare)
        ? b.monthlyBrokerShare
        : [],
    totalRecipientAllocatedCents: b.totalRecipientAllocatedCents ?? 0,
  };
}
